import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/sys/position"

const sysPosition = {
  positionList() {
    return axios.get(pre + `/positionList`);
  },
  page(page, limit, name) {
    return axios.get(pre + `/page`, {params: {page: page, limit: limit, name: name}});
  },
  // post提交
  savePosition(params) {
    return axios.post(pre + `/savePosition`, qs.stringify(params));
  },
  delPosition(id) {
    return axios.delete(pre + `/delPosition`, {params: {id: id}});
  },
  positionInfo(id) {
    return axios.get(pre + `/positionInfo`, {params: {id: id}});
  },

}
export default sysPosition;



// WEBPACK FOOTER //
// ./src/api/sys/position.js